'use client'

import Link from 'next/link'
import { ArrowRight } from 'lucide-react'

interface SectionHeaderProps {
  title: string
  viewAllHref?: string
  viewAllLabel?: string
  description?: string
  className?: string
}

export function SectionHeader({
  title,
  viewAllHref,
  viewAllLabel = '전체 보기',
  description,
  className = '',
}: SectionHeaderProps) {
  return (
    <div
      className={[
        'flex flex-col gap-2',
        'sm:flex-row sm:items-end sm:justify-between',
        'mb-4 pb-3 border-b border-gray-200',
        className,
      ].join(' ')}
    >
      <div className="min-w-0">
        <h2 className="text-lg font-bold text-gray-900 leading-tight">{title}</h2>
        {description && (
          <p className="mt-1 text-sm text-gray-500 leading-relaxed">{description}</p>
        )}
      </div>

      {viewAllHref && (
        <Link
          href={viewAllHref}
          className={[
            'inline-flex items-center gap-1.5',
            'text-sm font-semibold text-blue-600 hover:text-blue-700',
            'rounded-lg px-2 py-1 -mr-2', // ✅ 클릭 영역 확장 + 우측 정렬감
            'hover:bg-blue-50 transition-colors',
            'self-start sm:self-auto', // ✅ 모바일에서 왼쪽에 자연스럽게
            'whitespace-nowrap',
          ].join(' ')}
        >
          {viewAllLabel}
          <ArrowRight className="w-4 h-4" />
        </Link>
      )}
    </div>
  )
}
